var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbabygirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 11.4 11.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.16,5.7c0,3.02-2.44,5.46-5.46,5.46S.24,8.71.24,5.7,2.68.24,5.7.24s5.46,2.44,5.46,5.46Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79,5.7c0,2.26-1.83,4.09-4.09,4.09S1.6,7.96,1.6,5.7,3.44,1.61,5.7,1.61s4.09,1.83,4.09,4.09Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: ".48px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbabygirl);
export default __webpack_public_path__ + "static/media/KIDSBABYGIRL.54b0dbba4f7c319a7a3e0c17df56ace7.svg";
export { ForwardRef as ReactComponent };